import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=a3462a7a&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=a3462a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3462a7a",
  null
  
)

export default component.exports